function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { getChannelHistoryForOffset, getLiveChannels, setCurrentChannel } from "@common/actions";
import BackLink from "@common/components/BackLink";
import ChannelLogo from "@common/components/ChannelLogo";
import protect from "@common/components/HoC/protect";
import LoadProgressBar from "@common/components/LoadProgressBar";
import VerticalInfiniteScroll from "@common/components/VerticalInfiniteScroll";
import { dateDifferenceInDays, getDayOfWeekAndDate, getStartOfDayDateObject, getToday } from "@common/services/helpers";
import { isEmpty } from "lodash";
var ChannelListingForDate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ChannelListingForDate, PureComponent);
    var _super = _create_super(ChannelListingForDate);
    function ChannelListingForDate(props) {
        _class_call_check(this, ChannelListingForDate);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            content: []
        };
        return _this;
    }
    _create_class(ChannelListingForDate, [
        {
            key: "renderChannelLogo",
            value: function renderChannelLogo() {
                var _this_props = this.props, match = _this_props.match, logos = _this_props.logos;
                var channelId = match.params.channel;
                var template = null;
                if (logos[channelId]) {
                    template = /*#__PURE__*/ _jsx(ChannelLogo, {
                        hasName: false,
                        channelLogo: logos[channelId],
                        isCentered: false
                    });
                }
                return template;
            }
        },
        {
            key: "renderBackLink",
            value: function renderBackLink() {
                var _this_props = this.props, currentChannel = _this_props.currentChannel, i18n = _this_props.i18n, match = _this_props.match;
                var template = null;
                if (currentChannel.channel) {
                    var date = getStartOfDayDateObject(+match.params.date);
                    var name = getDayOfWeekAndDate(date, i18n.days, i18n.months, {
                        today: i18n.common.today,
                        yesterday: i18n.common.yesterday
                    });
                    var route = "/channel/".concat(currentChannel.channel.id);
                    template = /*#__PURE__*/ _jsx(BackLink, {
                        name: name,
                        route: route,
                        className: "margin-bottom-med"
                    });
                }
                return template;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, history = _this_props.history, i18n = _this_props.i18n, logos = _this_props.logos, screenType = _this_props.screenType;
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(LoadProgressBar, {
                            items: [
                                this.state.content
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "current-channel-container",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "listing-container",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "channel-logo-container margin-top-med margin-bottom-med",
                                        children: this.renderChannelLogo()
                                    }),
                                    this.renderBackLink(),
                                    /*#__PURE__*/ _jsx(VerticalInfiniteScroll, {
                                        content: this.state.content || [],
                                        channelsLogos: logos,
                                        history: history,
                                        i18n: i18n,
                                        getPage: function() {},
                                        screenType: screenType,
                                        hasLogo: false,
                                        showCategories: true,
                                        showHasLabel: true,
                                        category: {},
                                        isCardBig: true,
                                        isCardWithoutHeader: true
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, _$getChannelHistoryForOffset, liveChannels, match, _$setCurrentChannel, _$getLiveChannels, channelId, channel, date, today, offset, utcOffset, timestamp;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_props = _this.props, _$getChannelHistoryForOffset = _this_props.getChannelHistoryForOffset, liveChannels = _this_props.liveChannels, match = _this_props.match, _$setCurrentChannel = _this_props.setCurrentChannel, _$getLiveChannels = _this_props.getLiveChannels;
                                channelId = match.params.channel;
                                if (!isEmpty(liveChannels)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _$getLiveChannels({
                                        filterByAccess: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                channel = liveChannels[channelId];
                                if (channel) {
                                    _$setCurrentChannel({
                                        channel: channel,
                                        linkIsShown: true
                                    });
                                    date = getStartOfDayDateObject(+match.params.date);
                                    today = getToday();
                                    offset = dateDifferenceInDays(date, today);
                                    utcOffset = date.getTimezoneOffset() / 60;
                                    timestamp = date.getTime();
                                    _$getChannelHistoryForOffset(channelId, timestamp, offset, utcOffset);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                var _this_props = this.props, currentChannel = _this_props.currentChannel, _$getChannelHistoryForOffset = _this_props.getChannelHistoryForOffset, liveChannels = _this_props.liveChannels, match = _this_props.match, _$setCurrentChannel = _this_props.setCurrentChannel;
                var channelId = match.params.channel;
                var channelGetsAvailable = !prevProps.liveChannels[channelId] && liveChannels[channelId];
                var date = getStartOfDayDateObject(+match.params.date);
                var today = getToday();
                var offset = dateDifferenceInDays(date, today);
                var utcOffset = date.getTimezoneOffset() / 60;
                var timestamp = date.getTime();
                if (channelGetsAvailable) {
                    _$setCurrentChannel({
                        channel: liveChannels[channelId],
                        linkIsShown: true
                    });
                    _$getChannelHistoryForOffset(channelId, timestamp, offset, utcOffset);
                }
                var hasEpgs = currentChannel && Array.isArray(currentChannel.epgs[timestamp]);
                var epgsHasChanged = prevProps.currentChannel.epgs[timestamp] !== currentChannel.epgs[timestamp];
                if (hasEpgs && epgsHasChanged) {
                    this.setState({
                        content: _to_consumable_array(currentChannel.epgs[timestamp]).reverse()
                    });
                }
            }
        }
    ]);
    return ChannelListingForDate;
}(PureComponent);
var mapStateToProps = function(param) {
    var currentChannel = param.currentChannel, liveChannels = param.liveChannels, logos = param.logos, screenType = param.screenType;
    return {
        currentChannel: currentChannel,
        liveChannels: liveChannels,
        logos: logos,
        screenType: screenType
    };
};
export default protect(connect(mapStateToProps, {
    getChannelHistoryForOffset: getChannelHistoryForOffset,
    setCurrentChannel: setCurrentChannel,
    getLiveChannels: getLiveChannels
})(ChannelListingForDate));
